import { render, staticRenderFns } from "./QuickReviewing.vue?vue&type=template&id=06c908d4&scoped=true&"
import script from "./QuickReviewing.vue?vue&type=script&lang=ts&"
export * from "./QuickReviewing.vue?vue&type=script&lang=ts&"
import style0 from "./QuickReviewing.vue?vue&type=style&index=0&id=06c908d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c908d4",
  null
  
)

export default component.exports